export default __webpack_public_path__ + "static/compostable_animation-663bd619004d81ff43010649dc274831.gif";